export const commonConstants = {
    GET_ARTICLE_BY_REDIRECT_URL_SUCCESS: "GET_ARTICLE_BY_REDIRECT_URL_SUCCESS",
    GET_ARTICLE_BY_REDIRECT_URL_FAILURE: "GET_ARTICLE_BY_REDIRECT_URL_FAILURE",

    CLEAR_ARTICLE: "CLEAR_ARTICLE",
  };
  